import DepartmentServices from '@/services-ts/User/DepartmentServices'
import EmployeeServices from '@/services-ts/User/EmployeeServices'
import EmployeeTypeServices from '@/services-ts/User/EmployeeTypeServices'
import LevelServices from '@/services-ts/User/LevelServices'
import LocationServices from '@/services-ts/User/LocationServices'
import PositionServices from '@/services-ts/User/PositionServices'
import RoleServices from '@/services-ts/User/RoleServices'
import SelfRegistrationServices from '@/services-ts/User/SelfRegistrationServices'
import UserServices from '@/services-ts/User/UserServices'

const UserAPI = (apiUser: string) => {
  return {
    UserServices: new UserServices(apiUser),
    EmployeeServices: new EmployeeServices(apiUser),
    RoleServices: new RoleServices(apiUser),
    DepartmentServices: new DepartmentServices(apiUser),
    EmployeeTypeServices: new EmployeeTypeServices(apiUser),
    LocationServices: new LocationServices(apiUser),
    PositionServices: new PositionServices(apiUser),
    LevelServices: new LevelServices(apiUser),
    SelfRegistrationServices: new SelfRegistrationServices(apiUser),
  }
}

export default UserAPI
